<template>
    <div>
        <HeaderSection icon="fas fa-folder-open" title="Unificación de expedientes">
            <template slot="buttons">
                <el-button-group>
                    <el-button
                        size="mini"
                        type="danger"
                        icon="el-icon-arrow-left"
                        @click="goToBack">
                        Cerrar
                    </el-button>
                </el-button-group>
            </template>
        </HeaderSection>
        <div>
            <el-form @submit.native.prevent
                     ref="unifyForm"
                     :model="unifyForm"
                     label-width="120px"
                     label-position="top">
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item :rules="{ required: true, message: 'El campo es requerido', trigger: 'change' }"
                                      prop="record"
                                      label="Expediente">
                            <el-input v-my-only-alphanumeric="{maxChars: 70}" v-model="unifyForm.record"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="Tipo de trámite" prop="cat_category_id"
                                      :rules="{ required: true, message: 'El campo es requerido', trigger: 'change' }">

                            <el-select v-model="unifyForm.cat_category_id"
                                       filterable
                                       v-loading="loading"
                                       element-loading-text=""
                                       element-loading-spinner="el-icon-loading"
                                       value-key="id"
                                       style="width:100%;" placeholder="Seleccionar">
                                <el-option
                                    v-for="item in catalogsFilter(11)"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Trámite" prop="cat_procedure_id"
                                      :rules="{ required: true, message: 'El campo es requerido', trigger: 'change' }">
                            <el-select v-model="unifyForm.cat_procedure_id"
                                       filterable
                                       v-loading="loading"
                                       element-loading-text=""
                                       element-loading-spinner="el-icon-loading"
                                       style="width:100%;" placeholder="Seleccionar">
                                <el-option
                                    v-for="item in catalogsFilter(5).filter(up => up.cat_category_id == unifyForm.cat_category_id)"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <br>
                <el-row>
                    <el-col>
                        <el-button @click="searchable()">
                            Buscar
                        </el-button>
                    </el-col>
                </el-row>
            </el-form>
            <br>

            <el-collapse v-if="unifyData.length > 0"  accordion v-model="activeName">
                <el-collapse-item v-for="(item,key) in unifyData" v-if="item.data_form" :key="key" :title="key + 1">
                    <template slot="title">
                        <el-button type="text" icon="el-icon-circle-plus-outline">
                            Folio: {{item.folio}}
                        </el-button>
                        <el-tooltip class="item" effect="dark" content="Ver Documentos">
                            <el-button type="primary" icon="far fa-eye"
                                       size="mini"
                                       plain @click="getDocs(item.id, item.folio)">
                            </el-button>
                        </el-tooltip>
                    </template>
                    <el-card >
                        <el-row :gutter="5"
                                :key="key2"
                                v-for="(item2,key2) in item.data_form"
                                v-if="item2.data_info.form_field_type_id != 9 && filterData(item2) != null"
                                style="border: 0.8px solid black; padding: 11px">
                            <el-col :span="12">
                                <label
                                    v-if="item2.data_info.form_field_type_id != 9"
                                    class="el-form-item__label"
                                    style="font-size: 8pt !important;">
                                    {{item2.data_info.label}}:
                                </label>
                            </el-col>
                            <el-col :span="12">
                                <label
                                    class="el-form-item__label"
                                    style="font-weight: bold !important; font-size: 8pt !important; text-align: center !important">
                                    {{filterData(item2)}}
                                </label>
                            </el-col>
                        </el-row>
                    </el-card>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>

<script>
    import HeaderSection from "../../../partials/HeaderSection";
    export default {
        components: {HeaderSection},

        data(){
          return{
              unifyForm: {},
              unifyData: [],
              activeName: null,
              catalogs: []

          }
        },

        watch:{
          'unifyForm.cat_category_id' (value){
              if(value && this.unifyForm.cat_procedure_id){
                  this.unifyForm.cat_procedure_id = ''
              }
          }
        },

        created() {
            this.loading = true;
            axios.get('/api/catalogs-forms', {params: {all: true}}).then(response => {
                if (response.data.success) {
                    this.catalogs = response.data.catalogs;
                }
                this.loading = false;
            })
        },

        methods:{
            goToBack(){
                setTimeout(() => {
                    window.close();
                }, 500);
            },

            searchable(){
                this.$refs['unifyForm'].validate(valid => {
                    if(valid){
                        let _params = {
                            ...this.unifyForm
                        }
                        axios.post('/api/get-records', _params).then(response => {
                            if (response.data.success) {
                                this.unifyData = response.data.unifyData;
                            }
                        })
                    }else{
                        this.$store.dispatch('notifications/ok', {msg: 'Complete los campos requeridos'}, {root: true});

                    }
                })

            },

            filterData(item) {
                let _name = null;
                if (item && item.data_info.form_field_type_id == 1 || item.data_info.form_field_type_id == 2) {
                    _name = item.textData;
                } else if (item && item.data_info.form_field_type_id == 4) {
                    _name = item.booleanData;
                } else if (item && item.data_info.form_field_type_id == 5) {
                    let _options = [];
                    let _system_catalog_id = item.data_info.system_catalog_id;
                    let _system_option_id = item.option_system_catalog_id;

                    let _name_catalog = this.catalogs.filter(up => up.id == _system_catalog_id);
                    _options = _.head(_name_catalog).options;
                    _name = _options.filter(up => up.id == _system_option_id);
                    _name = _.head(_name);
                    _name = _name && _name.name ? _name.name : 'Sin información';


                } else if (item && item.data_info.form_field_type_id == 4) {
                    _name = item.booleanData;
                } else if (item && item.data_info.form_field_type_id == 10) {
                    _name = item.dataNumber;
                }
                return _name;
            },

            getDocs(id, folio) {
                if (id) {
                    let params = {
                        ...this.inbox,
                        perPage: this.perPage,
                        sipac_request_id: id,
                    };
                    this.loading = true;
                    this.sipac_request_id = id;
                    axios.get('/api/get-prints-log', {params}).then(response => {
                        if (response.data.success) {
                            this.showLogs = true;
                            this.logs = response.data.logs
                            this.customFolio = folio
                        } else {
                            this.$store.dispatch('notifications/error', {msg: response.data.message}, {root: true});
                        }
                        this.loading = false;
                    }).catch(error => {
                        console.log('getDocs', error);
                        this.loading = false;
                        this.$notify({
                            type: 'error',
                            message: 'No se pudo completar la acción'
                        });
                    });
                }
            },

            catalogsFilter(id, options) {
                let _options = [];
                if (id != 9) {
                    _.forEach(this.catalogs, (item, key) => {
                        if (item && item.id == id) {
                            _options = item.options;
                        }
                    })
                    return _options
                }

            },
        }
    }
</script>

<style scoped>

</style>
